// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".imageUploader_root__1SLCA {\n  width: 200px; }\n  .imageUploader_root__1SLCA .imageUploader_text__2ceTg {\n    font-weight: 500;\n    font-size: 10px;\n    line-height: 15px;\n    color: #464646; }\n", ""]);
// Exports
exports.locals = {
	"root": "imageUploader_root__1SLCA",
	"text": "imageUploader_text__2ceTg"
};
module.exports = exports;
